import { render, staticRenderFns } from "./InsureNotice.vue?vue&type=template&id=fc149b5a&scoped=true&"
import script from "./InsureNotice.vue?vue&type=script&lang=js&"
export * from "./InsureNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc149b5a",
  null
  
)

export default component.exports